import React from 'react';
import Modal from 'react-bootstrap/Modal';
import './infoModal.css';

// Shared shell for the Education and Work Experience dialogs. The header stays
// put and the body scrolls, so long content never pushes the title off screen.
export default function InfoModal({ title, children, ...modalProps }) {
  return (
    <Modal
      {...modalProps}
      size="lg"
      scrollable
      centered
      dialogClassName="info-modal"
      aria-labelledby="info-modal-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="info-modal-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
}
